import { shape, string, bool } from 'prop-types';

export const messageShape = shape({
  discussionId: string,
  userId: string,
  userFullName: string,
  partyName: string,
  message: string,
  sendingDate: string,
  isMyPartyMessage: bool,
}).isRequired;